// @flow
import React from 'react';
import classNames from 'classnames';
import { Spinner } from 'moods-react/Spinner';

import './ImageLoader.scss';

type Props = {
  image: string,
  altText: string,
  imageStyle?: Object,
  replacementStyle?: Object,
  className?: string,
  type?: string,
  overlayText?: string,
  isAccessories?: boolean,
  extraPadding?: boolean,
};

type State = {
  imageFailed: boolean,
  imageLoaded: boolean,
  firstLoad: boolean,
};

class ImageLoaderComponent extends React.Component<Props, State> {
  static displayName = 'ImageLoader';

  constructor(props: Props): void {
    super(props);
    this.state = {
      imageLoaded: false,
      imageFailed: false,
      firstLoad: true,
      image: props.image,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (this.props.image !== nextProps.image) {
      this.setState({ imageLoaded: false, imageFailed: false });
      setTimeout(() => {
        this.setState({ image: nextProps.image });
      }, 500);
    }
  }

  onError = (): void => {
    this.setState({ imageLoaded: false, imageFailed: true, firstLoad: false });
  };

  onLoad = (): void => {
    this.setState({ imageLoaded: true, imageFailed: false, firstLoad: false });
  };

  showCurrentImage(): Element {
    const { imageFailed, imageLoaded, firstLoad, image } = this.state;
    const { altText, imageStyle, overlayText } = this.props;

    if (imageFailed) {
      return <div className="image-loader-component__img-replacement" style={this.props.replacementStyle} />;
    }

    const classes = classNames('image-loader-component__img', {
      'image-loader-component__img-faded': !imageLoaded,
      'image-loader-component__img-hidden': firstLoad,
      'image-loader-component__img-text-overlay': overlayText,
    });

    return (
      <img
        src={image}
        alt={altText}
        className={classes}
        style={imageStyle}
        onLoad={this.onLoad}
        onError={this.onError}
        loading="lazy"
      />
    );
  }

  render(): Element {
    const { imageLoaded, imageFailed } = this.state;
    const { className, type, noBackground, overlayText, isAccessories, extraPadding } = this.props;

    const classnames = classNames('image-loader-component', className, {
      'image-loader-component--square': type === 'square',
      'image-loader-component--no-bg': noBackground,
      'image-loader-component--is-accessories': isAccessories,
      'image-loader-component--extra-padding': extraPadding,
    });

    return (
      <div className={classnames}>
        <div className="image-loader-component__container">
          {this.showCurrentImage()}
          {!imageLoaded && !imageFailed && (
            <div className="image-loader-component__loader">
              <Spinner />
            </div>
          )}
          {overlayText ? (
            <div className="image-loader-component__text-overlay-container">
              <div className="image-loader-component__text-overlay u-fontFamily-primaryMedium u-fontSize-xxl">
                {overlayText}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default ImageLoaderComponent;
